// Nested attribute helper: detaches subform from existing record so that new one can be created inline.
// Used for eg. reassigning person in charge.
//

class Detacher {
  constructor(el) {
    this.fieldset = el;
    this.detacher = el.querySelector('[data-role="detacher"]');
    this.attacher = el.querySelector('[data-role="attacher"]');
    this.detached = el.querySelectorAll('[data-detach]');
    if (this.detacher) {
      this.detacher.addEventListener("click", this.setAttachementState.bind(this));
    }
  }

  detachFields(value, id, suggestion) {
    this.attacher.disabled = true
    this.detached.forEach((el) => {
      el.removeAttribute('disabled');
      el.value = "";
    });
    this.fieldset.classList.add('detached');
  }

  attachFields(e) {
    this.attacher.removeAttribute('disabled')
    this.detached.forEach((el) => {
      el.disabled = true;
      el.value = el.dataset.originally || "";
    });
    this.fieldset.classList.remove('detached');
  }

  setAttachementState() {
    if (this.detacher.checked) {
      this.detachFields();
    } else {
      this.attachFields();
    }
  }
}

function detacher(el) {
  return new Detacher(el);
}

export default detacher;